/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowUp = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M12 3.9 6.5 9.5l1 1 3.8-3.7V20h1.5V6.8l3.7 3.7 1-1z" />
	</SVG>
);

export default arrowUp;
